const integerValue = (value) => {
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) ? parsed : 0;
};

let addedSequence = 0;
const addedKey = (prefix) => `new-${prefix}-${Date.now()}-${addedSequence += 1}`;

const derivedPoolingGroup = (entity, erpCompanyId) => {
  const previousDefault = entity.erpCompanyId > 0 ? `entity-${entity.erpCompanyId}` : "";
  const usesDefault = !entity.poolingGroupId || entity.poolingGroupId === previousDefault;
  if (!usesDefault) return entity.poolingGroupId;
  return erpCompanyId > 0 ? `entity-${erpCompanyId}` : "";
};

const PortfolioMappingForm = ({ portfolio, onChange }) => {
  const updateEntity = (key, change) => onChange({
    ...portfolio,
    legalEntities: portfolio.legalEntities.map((item) => (
      item._clientKey === key ? { ...item, ...change } : item
    )),
  });
  const removeEntity = (key) => onChange({
    ...portfolio,
    legalEntities: portfolio.legalEntities.filter((item) => item._clientKey !== key),
  });
  const addEntity = () => onChange({
    ...portfolio,
    legalEntities: [...portfolio.legalEntities, {
      _clientKey: addedKey("entity"),
      erpCompanyId: 0,
      name: "",
      poolingGroupId: "",
      state: "active",
    }],
  });
  const updateProject = (key, change) => onChange({
    ...portfolio,
    projects: portfolio.projects.map((item) => (
      item._clientKey === key ? { ...item, ...change } : item
    )),
  });
  const removeProject = (key) => onChange({
    ...portfolio,
    projects: portfolio.projects.filter((item) => item._clientKey !== key),
  });
  const addProject = () => onChange({
    ...portfolio,
    projects: [...portfolio.projects, {
      _clientKey: addedKey("project"),
      key: "",
      erpProjectId: 0,
      name: "",
      legalEntityId: 0,
      buildingId: null,
      wbsCodes: [],
      costCenters: [],
      state: "active",
    }],
  });
  const updateCenter = (projectKey, centerKey, change) => {
    const project = portfolio.projects.find((item) => item._clientKey === projectKey);
    updateProject(projectKey, {
      costCenters: project.costCenters.map((center) => (
        center._clientKey === centerKey ? { ...center, ...change } : center
      )),
    });
  };
  const removeCenter = (projectKey, centerKey) => {
    const project = portfolio.projects.find((item) => item._clientKey === projectKey);
    updateProject(projectKey, { costCenters: project.costCenters.filter((item) => item._clientKey !== centerKey) });
  };
  const addCenter = (projectKey) => {
    const project = portfolio.projects.find((item) => item._clientKey === projectKey);
    updateProject(projectKey, { costCenters: [...project.costCenters, {
      _clientKey: addedKey("center"),
      id: 0,
      role: "construction",
      cashEffect: true,
    }] });
  };
  return <section className="governance-section" aria-labelledby="mapping-title">
    <header><div><span className="director-eyebrow">Estrutura</span><h2 id="mapping-title">Mapeamento do portfólio</h2></div></header>
    <div className="governance-grid governance-grid--two">
      <label>Nome do portfólio<input value={portfolio.name} onChange={(event) => onChange({ ...portfolio, name: event.target.value })} /></label>
      <label>Estado<select value={portfolio.state} onChange={(event) => onChange({ ...portfolio, state: event.target.value })}><option value="active">Ativo</option><option value="inactive">Inativo</option></select></label>
    </div>

    <div className="governance-subsection">
      <div className="governance-subsection__title"><h3>Entidades jurídicas</h3><button type="button" onClick={addEntity}>Adicionar entidade</button></div>
      {portfolio.legalEntities.map((entity) => <fieldset key={entity._clientKey} className="governance-card">
        <legend>{entity.name || "Nova entidade"}</legend>
        <div className="governance-grid">
          <label>ID no ERP<input aria-label={`ID ERP de ${entity.name || "nova entidade"}`} type="number" value={entity.erpCompanyId} onChange={(event) => {
            const erpCompanyId = integerValue(event.target.value);
            updateEntity(entity._clientKey, {
              erpCompanyId,
              poolingGroupId: derivedPoolingGroup(entity, erpCompanyId),
            });
          }} /></label>
          <label>Nome<input value={entity.name} onChange={(event) => updateEntity(entity._clientKey, { name: event.target.value })} /></label>
          <label>Estado<select value={entity.state} onChange={(event) => updateEntity(entity._clientKey, { state: event.target.value })}><option value="active">Ativa</option><option value="inactive">Inativa</option></select></label>
        </div>
        <button type="button" className="governance-remove" onClick={() => removeEntity(entity._clientKey)}>Remover entidade</button>
      </fieldset>)}
    </div>

    <div className="governance-subsection">
      <div className="governance-subsection__title"><h3>Projetos e centros de custo</h3><button type="button" onClick={addProject}>Adicionar projeto</button></div>
      {portfolio.projects.map((project) => <fieldset key={project._clientKey} className="governance-card">
        <legend>{project.name || "Novo projeto"}</legend>
        <div className="governance-grid">
          <label>Chave do projeto<input value={project.key} onChange={(event) => updateProject(project._clientKey, { key: event.target.value })} /></label>
          <label>ID do projeto no ERP<input type="number" value={project.erpProjectId} onChange={(event) => updateProject(project._clientKey, { erpProjectId: integerValue(event.target.value) })} /></label>
          <label>Nome<input value={project.name} onChange={(event) => updateProject(project._clientKey, { name: event.target.value })} /></label>
          <label>Entidade jurídica<select value={project.legalEntityId} onChange={(event) => updateProject(project._clientKey, { legalEntityId: integerValue(event.target.value) })}><option value={0}>Selecione</option>{portfolio.legalEntities.map((entity) => <option key={entity._clientKey} value={entity.erpCompanyId}>{entity.name || entity.erpCompanyId}</option>)}</select></label>
          <label>ID da obra<input value={project.buildingId || ""} onChange={(event) => updateProject(project._clientKey, { buildingId: event.target.value || null })} /></label>
          <label>Códigos WBS<input value={(project.wbsCodes || []).join(", ")} onChange={(event) => updateProject(project._clientKey, { wbsCodes: event.target.value.split(",").map((item) => item.trim()).filter(Boolean) })} /></label>
          <label>Estado<select value={project.state} onChange={(event) => updateProject(project._clientKey, { state: event.target.value })}><option value="active">Ativo</option><option value="inactive">Inativo</option></select></label>
        </div>
        <div className="governance-centers">
          <div className="governance-subsection__title"><h4>Centros de custo</h4><button type="button" onClick={() => addCenter(project._clientKey)}>Adicionar centro</button></div>
          {project.costCenters.map((center) => <div className="governance-center-row" key={center._clientKey}>
            <label>ID<input type="number" value={center.id} onChange={(event) => updateCenter(project._clientKey, center._clientKey, { id: integerValue(event.target.value) })} /></label>
            <label>Papel<select value={center.role} onChange={(event) => updateCenter(project._clientKey, center._clientKey, { role: event.target.value, ...(event.target.value === "permutation" ? { cashEffect: false } : {}) })}><option value="administrative">Administrativo</option><option value="revenue">Receita</option><option value="construction">Obra</option><option value="permutation">Permuta</option></select></label>
            <label className="governance-checkbox"><input aria-label={`Efeito de caixa do centro ${center.id}`} type="checkbox" checked={center.cashEffect} disabled={center.role === "permutation"} onChange={(event) => updateCenter(project._clientKey, center._clientKey, { cashEffect: event.target.checked })} />Efeito de caixa</label>
            <button type="button" className="governance-remove" onClick={() => removeCenter(project._clientKey, center._clientKey)}>Remover</button>
          </div>)}
        </div>
        <button type="button" className="governance-remove" onClick={() => removeProject(project._clientKey)}>Remover projeto</button>
      </fieldset>)}
    </div>
  </section>;
};

export default PortfolioMappingForm;
